module.exports = __webpack_public_path__ + "static/scania-b560cf51fa6439b45ce533aa263a9099.jpg";